import Splide from '@splidejs/splide';
import './index.scss';

const Slider = (sliderName, options = {}) => new Splide(sliderName, options);

export default Slider;
